<div
  class="input-area-file"
  [ngClass]="{ 'file-over': fileOver() }"
  (dragenter)="onDragEnter($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <input
    type="file"
    #fileDropRef
    id="fileDropRef"
    class="hidden"
    [multiple]="multiple()"
    [accept]="accept()"
    (change)="fileBrowseHandler($any($event.target).files)"
  />

  <div class="input-area-file__inner">
    <div class="input-area-file__orb">
      <svg
        class="h-8 w-8"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path
          d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12"
        />
      </svg>
    </div>

    <div class="flex flex-col items-center gap-2">
      <p class="text-base font-semibold text-gray-900">
        Carica le foto dell'immobile
      </p>
      <p class="input-area-file__copy max-w-md text-sm leading-6 text-gray-500">
        Formato JPG e JPEG. Carica tutte le immagini in un'unica sessione per
        garantire qualità uniforme su ogni ambiente.
      </p>
    </div>

    <div class="flex flex-col items-center gap-3">
      <button
        class="btn-solid-blue-casa-doc min-w-52"
        (click)="fileDropRef.click()"
      >
        Sfoglia i file
      </button>
      <p class="input-area-file__drag-hint text-xs text-gray-400">
        oppure trascina e rilascia
      </p>
    </div>

    <div
      class="flex flex-col items-center gap-2"
      [ngClass]="{ invisible: !files().length }"
    >
      <span class="text-xs font-medium text-gray-500"
        >{{ files().length }} file pronti</span
      >
      <button class="btn-outline-gray text-sm" (click)="onClearAll()">
        Rimuovi
      </button>
    </div>
  </div>
</div>
